import ReduxHelper, { setFilterFromAction } from 'lib/ReduxHelper';
import { GARAGES_ACTION_TYPES as PAT } from './Garages.actions';
import { history } from '../Store';

const defaultAuctionsFilterState = [];

export const defaultState = {
  filters: defaultAuctionsFilterState,
  message: null,
  fetchingGarages: false,
  garagesData: null,

  fetchingGarage: false,
  currentGarage: null,

  creatingGarage: false,
  creationError: null,
  garageCreated: false,

  updatingGarage: false,
  updateError: null,
  garageUpdated: false,

  deletingGarage: false,
  deleteteError: null,
  garageDeleted: false,
};

const garagesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case PAT.GARAGES_FETCH_DATA:
      return Object.assign({}, state, { fetchingGarages: true });
    case PAT.GARAGES_FETCH_DATA_SUCCESS:
      return Object.assign({}, state, {
        fetchingGarages: false,
        garagesData: action.payload.Garages,
        error: null,
      });
    case PAT.GARAGES_FETCH_DATA_FAIL:
      return Object.assign({}, state, {
        garagesData: null,
        message: ReduxHelper.formatMessage(action),
      });
    case PAT.GARAGES_CLEAR_DATA:
      return Object.assign({}, state, {
        fetchingGarages: false,
        garagesData: null,
        error: null,
      });

    case PAT.GARAGE_FETCH:
      return Object.assign({}, state, { fetchingGarage: true });
    case PAT.GARAGE_FETCH_SUCCESS:
      return Object.assign({}, state, {
        fetchingGarage: false,
        currentGarage: action.payload.Garages[0],
        error: null,
      });
    case PAT.GARAGE_FETCH_FAIL:
      return Object.assign({}, state, {
        currentGarage: null,
        message: ReduxHelper.formatMessage(action),
      });
    case PAT.GARAGE_CLEAR:
      return Object.assign({}, state, {
        fetchingGarage: false,
        currentGarage: null,
        error: null,
      });

    case PAT.GARAGE_CREATE:
      return Object.assign({}, state, { creatingGarage: true });
    case PAT.GARAGE_CREATE_SUCCESS:
      setTimeout(() => history.push({ pathname: '/all-garages' }));
      return Object.assign({}, state, {
        creatingGarage: false,
        garageCreated: true,
      });
    case PAT.GARAGE_CREATE_FAIL:
      return Object.assign({}, state, {
        creatingGarage: false,
        creationError: action.error,
      });

    case PAT.GARAGE_UPDATE:
      return Object.assign({}, state, { updatingGarage: true });
    case PAT.GARAGE_UPDATE_SUCCESS:
      setTimeout(() => history.push({ pathname: '/all-garages' }));
      return Object.assign({}, state, {
        updatingGarage: false,
        garageUpdated: true,
      });
    case PAT.GARAGE_UPDATE_FAIL:
      return Object.assign({}, state, {
        updatingGarage: false,
        updateError: action.error,
      });

    case PAT.GARAGE_DELETE:
      return Object.assign({}, state, { deletingGarage: true });
    case PAT.GARAGE_DELETE_SUCCESS:
      return Object.assign({}, state, {
        deletingGarage: false,
        garageDeleted: true,
      });
    case PAT.GARAGE_DELETE_FAIL:
      return Object.assign({}, state, {
        deletingGarage: false,
        deleteteError: action.error,
      });

    case PAT.SET_GARAGES_GRID_FILTER:
      return {
        ...state,
        filters: setFilterFromAction(action, state.filters),
      };
    case PAT.CLEAR_GARAGES_GRID_FILTER:
      return { ...state, filters: defaultAuctionsFilterState };
    default:
      return state;
  }
};

export default garagesReducer;
